<script>
    import { addCircleOutline, settings, trash, cube, map, pin, grid } from 'ionicons/icons/index.mjs';
    import { sortByName } from '../utils/Sort.svelte';
    export let node;
    export let mapId;
    export let isPublic;
    export let tooltips;
    let state = {};

    function openHandler(id) {
        state[id] = !state[id]
    }
</script>

{#if node}
    {#if node.child_count == 0}
        <ul class="menu menu-nav">
            <div class="tile tile-centered">
                <div class="tile-content">
                    <li class="menu-item {mapId == node.id ? "active" : ""}">{node.name}</li>
                </div>
                <div class="tile-action">
                    {#if node.type == "map"}
                        <a href={isPublic ? "/maps/" + node.id + "?public" : "/maps/" + node.id} class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="View Map">
                            <i class="svg">{@html map.md}</i>
                        </a>
                    {:else if node.type == "scene"}
                        <a href={isPublic ? "/scenes/" + node.id + "?public" : "/scenes/" + node.id} class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="View Scene">
                            <i class="svg">{@html cube.md}</i>
                        </a>
                    {:else if node.type == "table"}
                        <a href={isPublic ? "/tables/" + node.id + "?public" : "/tables/" + node.id} class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="View Table">
                            <i class="svg">{@html grid.md}</i>
                        </a>
                    {/if}
                </div>
            </div>
        </ul>
    {:else}
        <div class="accordion">
            {#if state[node.id]}
                <input type="checkbox" id={node.id} on:change={(e) => {openHandler(node.id)}} name="accordion-checkbox" hidden checked>
            {:else}
                <input type="checkbox" id={node.id} on:change={(e) => {openHandler(node.id)}} name="accordion-checkbox" hidden>
            {/if}
            <label class="accordion-header" for={node.id}>
                <div class="tile tile-centered">
                    <div class="tile-icon">
                        <div class="example-tile-icon">
                        {#if state[node.id]}
                            <i class="icon icon-arrow-down centered"></i>
                        {:else}
                            <i class="icon icon-arrow-right centered"></i>
                        {/if}
                        </div>
                    </div>
                    <div class="tile-content">
                        <div class="tile-title {mapId == node.id ? "active" : ""}">{node.name}</div>
                    </div>
                    <div class="tile-action">
                        {#if node.type == "map"}
                            <a href={isPublic ? "/maps/" + node.id + "?public" : "/maps/" + node.id} class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="View Map">
                                <i class="svg">{@html map.md}</i>
                            </a>
                        {:else if node.type == "scene"}
                            <a href={isPublic ? "/scenes/" + node.id + "?public" : "/scenes/" + node.id} class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="View Scene">
                                <i class="svg">{@html cube.md}</i>
                            </a>
                        {:else if node.type == "table"}
                            <a href={isPublic ? "/tables/" + node.id + "?public" : "/tables/" + node.id} class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="View Table">
                                <i class="svg">{@html grid.md}</i>
                            </a>
                    {/if}
                    </div>
                </div>    
            </label>
            {#if node && node.children}
                {#each node.children.sort(sortByName) as child}
                    <div class="accordion-body">
                        <svelte:self mapId={mapId} node={child} isPublic={isPublic} />
                    </div>
                {/each}
            {/if}
        </div>
    {/if}
{/if}

<style>
.accordion .accordion-header {
    cursor: pointer;
    user-select: none;
    height: 1rem;
    padding: 0.2rem 0rem 0.2rem 0.75rem;
}
.accordion .accordion-body {
    padding: 0;
    padding-left: 1rem;
    margin: 0;
}
.accordion .accordion-body:first-of-type {
    padding-top: 0.8rem;
}
.menu {
    padding: 0 0 0 0.8rem;
}
.menu .menu-item {
    padding: 0;
}
.tile-title.active {
    color: #00ab5f;
}
.menu-item.active {
    color: #00ab5f;
}
</style>